module.exports = __webpack_public_path__ + "static/img/1-3.9985ea1.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/1-3.png
// module id = 257
// module chunks = 0